var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRevenueGenerated(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.624,
    height: 31.159,
    viewBox: "0 0 35.624 31.159",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Revenue_Icon_1",
    "data-name": "Revenue Icon 1",
    transform: "translate(-478.3 -232.1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1619",
    "data-name": "Group 1619",
    transform: "translate(478.3 242.034)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1117",
    "data-name": "Path 1117",
    d: "M526.285,1361.388c-.43-.43-.843-.84-1.252-1.251-.055-.055-.1-.113-.154-.173a.391.391,0,0,1,.252-.657,7.237,7.237,0,0,1,.738-.064q1.728-.078,3.455-.146c.164-.006.33,0,.494.007a.31.31,0,0,1,.314.264,1.229,1.229,0,0,1,.028.306c-.043,1.065-.086,2.129-.14,3.192-.019.38-.063.758-.108,1.136-.026.218-.135.388-.378.395a.453.453,0,0,1-.29-.09c-.289-.255-.561-.53-.841-.795-.193-.183-.389-.365-.6-.557-.158.152-.3.288-.445.429q-3.856,3.831-7.71,7.663c-.566.562-1.144,1.111-1.722,1.661a.725.725,0,0,1-1.108.012q-1.432-1.374-2.841-2.77c-.81-.8-1.61-1.608-2.412-2.413a1.027,1.027,0,0,1-.1-.15c-.284.288-.533.547-.789.8-1.152,1.133-2.31,2.26-3.454,3.4a.873.873,0,0,1-.869.252,1.283,1.283,0,0,1-.881-1.294.692.692,0,0,1,.167-.3c.812-.84,1.621-1.683,2.448-2.508.944-.941,1.9-1.866,2.861-2.794a.708.708,0,0,1,.978-.01q.844.782,1.664,1.588,1.823,1.792,3.634,3.594c.043.042.091.081.162.144Z",
    transform: "translate(-505.217 -1359.094)",
    fill: "#82868b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1671",
    "data-name": "Rectangle 1671",
    width: 3.588,
    height: 5.143,
    transform: "translate(0 16.082)",
    fill: "#82868b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1672",
    "data-name": "Rectangle 1672",
    width: 3.588,
    height: 8.791,
    transform: "translate(5.322 12.433)",
    fill: "#82868b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1673",
    "data-name": "Rectangle 1673",
    width: 3.588,
    height: 6.04,
    transform: "translate(10.645 15.184)",
    fill: "#82868b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1674",
    "data-name": "Rectangle 1674",
    width: 3.588,
    height: 8.791,
    transform: "translate(15.968 12.433)",
    fill: "#82868b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1675",
    "data-name": "Rectangle 1675",
    width: 3.588,
    height: 13.15,
    transform: "translate(21.29 8.074)",
    fill: "#82868b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1622",
    "data-name": "Group 1622",
    transform: "translate(502.153 232.1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1118",
    "data-name": "Path 1118",
    d: "M3453.774,732.884l-.973-2.547h2.688c-.158.252-.3.482-.479.762a4.676,4.676,0,0,0,4.523-1.046,4.781,4.781,0,0,0,1.357-5.392c.145-.058.293-.118.442-.176s.3-.115.48-.183a5.872,5.872,0,0,1-7.03,7.77c-.309-.089-.475-.042-.618.234A5.829,5.829,0,0,1,3453.774,732.884Z",
    transform: "translate(-3450.435 -719.962)",
    fill: "#82868b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1119",
    "data-name": "Path 1119",
    d: "M3192.813,232.1c.327.851.632,1.649.958,2.5h-2.643l.468-.737a4.674,4.674,0,0,0-4.4.9,4.805,4.805,0,0,0-1.522,5.534l-.927.361a5.891,5.891,0,0,1,7.006-7.784c.35.081.562.066.719-.272A4.272,4.272,0,0,1,3192.813,232.1Z",
    transform: "translate(-3184.362 -232.1)",
    fill: "#82868b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1621",
    "data-name": "Group 1621",
    transform: "translate(2.423 2.973)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1120",
    "data-name": "Path 1120",
    d: "M3466.142,572.867a3.471,3.471,0,1,1-3.495-3.469A3.456,3.456,0,0,1,3466.142,572.867Z",
    transform: "translate(-3459.2 -569.398)",
    fill: "#82868b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1620",
    "data-name": "Group 1620",
    transform: "translate(2.143 1.036)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1121",
    "data-name": "Path 1121",
    d: "M3667.637,637.408v-1.136a1.489,1.489,0,0,1-.78-.46,1.153,1.153,0,0,1-.249-.748,1.06,1.06,0,0,1,.281-.747,1.131,1.131,0,0,1,.748-.349V633.7h.393v.268a1.166,1.166,0,0,1,.687.294,1.137,1.137,0,0,1,.326.649l-.687.089a.552.552,0,0,0-.326-.434v1.06a1.755,1.755,0,0,1,.887.457,1.08,1.08,0,0,1,.237.72,1.205,1.205,0,0,1-.3.828,1.306,1.306,0,0,1-.826.412v.507h-.393v-.494a1.258,1.258,0,0,1-.763-.35,1.447,1.447,0,0,1-.375-.828l.708-.076a.9.9,0,0,0,.162.374A.735.735,0,0,0,3667.637,637.408Zm0-2.848a.508.508,0,0,0-.255.185.48.48,0,0,0-.1.288.453.453,0,0,0,.087.267.606.606,0,0,0,.263.2Zm.394,2.886a.55.55,0,0,0,.33-.188.53.53,0,0,0,.127-.354.48.48,0,0,0-.107-.314.685.685,0,0,0-.352-.2v1.057Z",
    transform: "translate(-3666.5 -633.7)",
    fill: "#fff"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRevenueGenerated);
export default __webpack_public_path__ + "static/media/revenue_generated.0bb5f0188d769afff9b1e5f634082a9b.svg";
export { ForwardRef as ReactComponent };